import Add from './Add';
import Edit from './Edit';
import List from './List';
import reducer from './reducer';

const PayTypes = {
  List,
  Add,
  Edit,
  reducer
};

export default PayTypes;
